import { useRef } from "react";
import { formatMonth } from "../../constants";

const btnBase = {
  background: "#1e293b",
  border: "1px solid #334155",
  color: "#f1f5f9",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontFamily: "inherit",
  transition: "all .2s",
};

export default function MonthPicker({ value, onChange, style }) {
  const inputRef = useRef(null);

  const navigate = (dir) => {
    const [y, m] = value.split("-").map(Number);
    const d = new Date(y, (m - 1) + dir, 1);
    onChange(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`);
  };

  return (
    <div style={{
      display: "flex", alignItems: "center", gap: 4,
      background: "#0f172a", borderRadius: 10,
      border: "1px solid #1e293b", padding: 3,
      ...style,
    }}>
      <button
        onClick={() => navigate(-1)}
        title="الشهر السابق"
        style={{
          ...btnBase,
          width: 32, height: 32, borderRadius: 8,
          fontSize: 18, fontWeight: 700, lineHeight: 1,
        }}
        onMouseEnter={(e) => e.currentTarget.style.background = "#334155"}
        onMouseLeave={(e) => e.currentTarget.style.background = "#1e293b"}
      >
        ‹
      </button>

      <button
        onClick={() => inputRef.current?.showPicker()}
        title="اختيار شهر"
        style={{
          ...btnBase,
          background: "transparent",
          border: "none",
          padding: "4px 14px",
          fontSize: 13,
          fontWeight: 700,
          minWidth: 110,
          textAlign: "center",
          borderRadius: 7,
          height: 32,
        }}
        onMouseEnter={(e) => e.currentTarget.style.background = "#1e293b"}
        onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
      >
        {formatMonth(value)}
      </button>

      <input
        ref={inputRef}
        type="month"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          position: "absolute", opacity: 0, width: 0, height: 0,
          pointerEvents: "none",
        }}
      />

      <button
        onClick={() => navigate(1)}
        title="الشهر التالي"
        style={{
          ...btnBase,
          width: 32, height: 32, borderRadius: 8,
          fontSize: 18, fontWeight: 700, lineHeight: 1,
        }}
        onMouseEnter={(e) => e.currentTarget.style.background = "#334155"}
        onMouseLeave={(e) => e.currentTarget.style.background = "#1e293b"}
      >
        ›
      </button>
    </div>
  );
}
